// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#remote-media video {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  left: 0;\n  right: 0;\n}\n\n#local-media video {\n  width: 30%;\n  border: 8px solid rgba(0, 0, 0, 0.7);\n  margin-top: -5%;\n  align-self: flex-end;\n  justify-self: flex-end;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
